import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const PerthAirport = () => (
  <CostcoLocationTemplate
    warehouseName="Perth Airport"
    suburb="Perth Airport"
    state="Western Australia"
    stateShort="WA"
    address="Dunreath Dr, Perth Airport WA 6105"
    path="/costco/perth"
    nearbySuburbs={[
      'Redcliffe',
      'Belmont',
      'Rivervale',
      'Cloverdale',
      'Kewdale',
      'Ascot',
      'Bayswater',
      'Bassendean',
      'Guildford',
      'Midland',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the Perth Airport warehouse and the greater Perth metropolitan area. Whether you're a FIFO worker looking to purchase your first home, refinancing to take advantage of Perth's recovering property market, or investing in affordable east-coast alternatives, our brokers can help you earn Costco Shop Card rewards on settled loans."
    localContext={[
      'Perth\'s property market has seen strong recovery, with prices still offering significant value compared to Sydney and Melbourne — attracting interstate investors and local first home buyers alike.',
      'FIFO (Fly-In Fly-Out) workers represent a major segment of the Perth lending market, with specialised loan structures available to suit roster-based income patterns.',
      'The Perth Airport precinct and surrounding suburbs like Belmont, Rivervale, and Bayswater offer a mix of established homes and new developments within easy reach of the CBD.',
    ]}
    faqs={[
      {
        q: 'How do I claim my Costco Shop Card at the Perth Airport warehouse?',
        a: 'Apply for a loan through Manage Your Loans as a Costco Executive Member. Once your loan settles, we\'ll arrange your Shop Card reward. You can redeem it at the Perth Airport warehouse or any Costco in Australia.',
      },
      {
        q: 'Do you offer FIFO-friendly loan options?',
        a: 'Yes. We work with lenders who understand FIFO income structures, including roster-based earnings and remote area allowances. Our brokers can help you find the right loan to suit your work pattern.',
      },
      {
        q: 'Is Perth property still affordable compared to the east coast?',
        a: 'Perth remains more affordable than Sydney and Melbourne on median price comparisons, though growth has been strong. Our brokers can assess your borrowing capacity and help you find competitive rates in the current market.',
      },
      {
        q: 'Which Perth suburbs are covered by this service?',
        a: 'We serve all Perth metro suburbs including Redcliffe, Belmont, Rivervale, Cloverdale, Kewdale, Ascot, Bayswater, Bassendean, Guildford, Midland, and beyond. You can apply online from anywhere in WA.',
      },
    ]}
    suburbData={{
      suburb: 'Redcliffe',
      medianHouse: '$580,000',
      medianUnit: '$390,000',
      daysOnMarket: '18 days',
      rentalYield: '4.5%',
      population: '6,800',
      distanceToCostco: '3 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Belmont', medianHouse: '$620,000', medianUnit: '$400,000', daysOnMarket: '17 days' },
      { suburb: 'Rivervale', medianHouse: '$650,000', medianUnit: '$420,000', daysOnMarket: '16 days' },
      { suburb: 'Cloverdale', medianHouse: '$580,000', medianUnit: '$380,000', daysOnMarket: '18 days' },
      { suburb: 'Kewdale', medianHouse: '$600,000', medianUnit: '$390,000', daysOnMarket: '19 days' },
      { suburb: 'Ascot', medianHouse: '$850,000', medianUnit: '$480,000', daysOnMarket: '15 days' },
      { suburb: 'Bayswater', medianHouse: '$620,000', medianUnit: '$400,000', daysOnMarket: '17 days' },
      { suburb: 'Bassendean', medianHouse: '$640,000', medianUnit: '$410,000', daysOnMarket: '18 days' },
      { suburb: 'Guildford', medianHouse: '$550,000', medianUnit: '$360,000', daysOnMarket: '20 days' },
      { suburb: 'Midland', medianHouse: '$480,000', medianUnit: '$330,000', daysOnMarket: '22 days' },
    ]}
  />
);

export default PerthAirport;
